import React, { createContext, useEffect, useReducer } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookie from '../utils/Cookie';
import LoadingScreen from '../components/LoadingScreen';
import ToastHot from 'react-hot-toast';
import { TOKEN_KEY } from '../utils/constants';
import { CallWithAuth } from '../actions/apiAction';
import { ME_API_URL } from '../utils/apiUrl';
import { useAuth } from '@clerk/clerk-react';
import { hardSignOut } from '../services/authSession';

const initialAuthState = {
  isAuthenticated: false,
  isInitialised: false,
  user: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'INITIALISE': {
      const { isAuthenticated, user } = action.payload;

      return {
        ...state,
        isAuthenticated,
        isInitialised: true,
        user
      };
    }
    case 'LOGIN': {
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload
      };
    }
    case 'LOGOUT': {
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };
    }
    case 'userUpdate': {
      return {
        ...state,
        user: action.payload,
      };
    }
    case 'REGISTER': {
      const { user } = action.payload;

      return {
        ...state,
        isAuthenticated: true,
        user: action.payload
      };
    }
    default: {
      return { ...state };
    }
  }
};

const AuthContext = createContext({
  ...initialAuthState,
  Login: () => Promise.resolve(),
  Logout: () => { console.log('Logout') },
  updateUser: () => Promise.resolve(),
  RegisterUser: () => Promise.resolve(),
});

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [state, dispatch] = useReducer(reducer, initialAuthState);
  const { getToken, signOut } = useAuth();

  const fetchToken = async () => {
    const token = await getToken({
      template: process.env.REACT_APP_CLEARK_TEMPLATE_ID
    });
    return token;
  };

  const Logout = async () => {
    dispatch({ type: 'LOGOUT' });
    await hardSignOut(signOut);
  };

  const updateUser = (user) => {
    dispatch({ type: 'userUpdate', payload: user })

  }

  useEffect(() => {
    const initialise = async () => {
      try {
        const accessToken = await fetchToken(); //Cookie.getCookie(TOKEN_KEY);
        if (accessToken) {
          Cookie.setCookie(TOKEN_KEY, accessToken, 1);
          const response = await CallWithAuth("GET", ME_API_URL);
          if (response.data) {
            dispatch({
              type: 'INITIALISE',
              payload: {
                isAuthenticated: true,
                user: response.data ?? null,
              }
            });
          } else {
            Logout()
            window.location.href = "/login";
            ToastHot.error("Something went wrong, Server error");
            dispatch({
              type: 'INITIALISE',
              payload: {
                isAuthenticated: false,
                user: null,
              }
            });
          }
        } else {
          dispatch({
            type: 'INITIALISE',
            payload: {
              isAuthenticated: false,
              user: null,
            }
          });
        }
      } catch (err) {
        ToastHot.error("Something went wrong, Server error");
        console.log('error==>', err)
        dispatch({
          type: 'INITIALISE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
      }


    };

    initialise();
  }, []);

  if (!state.isInitialised) {
    return <LoadingScreen />;
  }

  return (
    <AuthContext.Provider
      value={{
        ...state,
        Logout,
        updateUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
